import { setAiGlobalSearch } from "@/store/feature/ai-course-finder/aiCourseFinderSlice";
import { useAppDispatch } from "@/store/hooks";
import Image from "next/image";
import { useRouter } from "next/navigation";

const TrendingPrograms = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const programs = [
    {
      labelImage: "/assets/gif/fire.gif",
      label: "HOT",
      image: "💻",
      title: "Technology & AI",
      description:
        "MS AI · MS CS · Data Science · Cybersecurity · Robotics · Cloud",
    },
    {
      labelImage: "",
      label: "",
      image: "💼",
      title: "Business & MBA",
      description: "MBA · BBA International · Fintech · Entrepreneurship",
    },
    {
      labelImage: "",
      label: "",
      image: "⚖️",
      title: "Law · LLB / LLM",
      description: "LLB · LLM Corporate · International Law",
    },
    {
      labelImage: "",
      label: "↑ RISING",
      image: "🏥",
      title: "Medicine & Health",
      description: "MBBS Abroad · MBA Healthcare · Bio-Medical",
    },
    {
      labelImage: "",
      label: "✦ FUTURE",
      image: "💰",
      title: "Finance & Fintech",
      description: "Msc Finance · FinTech · Quant Finance",
    },
    {
      labelImage: "",
      label: "",
      image: "📊",
      title: "Data Science",
      description: "Analytics · Machine Learning · Intelligence",
    },
    {
      labelImage: "",
      label: "",
      image: "🏗️",
      title: "Architecture & Design",
      description: "B.Arch · Interior · Graphic · Product Design",
    },
    {
      labelImage: "",
      label: "",
      image: "🌍",
      title: "Public Policy & IR",
      description: "MPA · MPP · MA International Relations · Global Studies",
    },
  ];
  const handleTagClick = (tag: string) => {
    dispatch(setAiGlobalSearch(tag));
    router.push("/ai-course-finder");
    document.body.classList.remove("!overflow-hidden");
  };
  return (
    <div className="bg-[#F5F4FF]">
      <div className="container max-w-[1400px] mx-auto py-[48px] md:py-[54px] lg:py-[60px] xl:py-[70px] 2xl:py-[86px] px-4 xxs:px-6 sm:px-[40px] bg-[#F5F4FF]">
        <h2 className="text-center ff_poppins text-[24px] xxs:text-[28px] xs:text-[32px] sm:text-2xl md:text-3xl lg:text-4xl xl:text-[48px] font-semibold uppercase mb-[24px]">
          Trending Programs 2026
        </h2>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-2 xxs:gap-x-3 gap-y-3 xxs:gap-y-4 lg:gap-5">
          {programs.map((program, index) => {
            const isFeaturedFirst = index === 0;
            const isFeaturedLast = index === programs.length - 1;
            const isFeatured = isFeaturedFirst || isFeaturedLast;

            const labelStyles: Record<string, string> = {
              "↑ RISING": "text-[#0B57D0] bg-[#E8F0FE]",
              "✦ FUTURE": "text-[#0D652D] bg-[#E6F4EA]",
              "HOT": "text-white bg-[#D9381E]",
            };

            return (
              <div
                key={index}
                onClick={() => handleTagClick(program.title)}
                className={`p-4 xxs:p-5 md:p-6 lg:p-8 border border-[#E8E8E8] rounded-[24px] relative cursor-pointer transition-colors
                ${isFeatured ? "col-span-2 lg:col-span-3" : ""}
               ${isFeaturedFirst
                    ? "bg-[#021A38] [box-shadow:inset_0px_4px_12px_rgba(255,255,255,0.25),0px_4px_12px_rgba(0,0,0,0.25)]"
                    : ""}
              `}
                style={
                  !isFeaturedFirst
                    ? {
                      boxShadow: "0px 4px 12px 0px #00000014, 0px 4px 4px 0px #1776F01A inset",
                      borderTop: "1.11px solid #E8E8E8",
                      background: "#FFFFFF",
                    }
                    : {}
                }
              >
                {program.label && (
                  <span
                    className={`absolute inline-flex items-center gap-1.5 top-4 right-4 ff_poppins font-semibold text-[10px] xxs:text-[11px] xs:text-xs sm:text-sm py-1.5 px-3 rounded-full ${labelStyles[program.label] ?? ""}`}
                  >
                    {program.labelImage && (
                      <Image
                        src={program.labelImage}
                        alt=""
                        width={14}
                        height={14}
                        className="w-3 h-3 xxs:w-3.5 xxs:h-3.5"
                        unoptimized
                      />
                    )}
                    {program.label}
                  </span>
                )}

                {/* Icon badge */}
                <div
                  className={`shrink-0 flex items-center justify-center w-8 h-8 xxs:w-11 xxs:h-11 md:w-12 md:h-12 lg:w-14 lg:h-14 rounded-lg xxs:rounded-xl ${isFeaturedFirst ? "" : "bg-[#FBF3E7]"
                    }`}
                >
                  <p className="text-lg xxs:text-2xl md:text-3xl lg:text-4xl leading-none ff_poppins">
                    {program.image}
                  </p>
                </div>

                <div className="mt-4 xxs:mt-6">
                  <p
                    className={`ff_poppins font-semibold ${isFeaturedFirst
                      ? "text-[16px] xxs:text-[18px] xs:text-[20px] sm:text-2xl md:text-3xl lg:text-4xl text-white"
                      : "text-[10px] xxs:text-[12px] xs:text-[13px] md:text-base lg:text-lg xl:text-xl text-[#111111]"
                      }`}
                  >
                    {program.title}
                  </p>
                  <p
                    className={`ff_poppins mt-2 ${isFeaturedFirst
                      ? "text-[10px] xxs:text-[12px] xs:text-[13px] sm:text-sm md:text-base lg:text-lg text-white/90"
                      : "text-[8px] xxs:text-[9px] xs:text-[10px] sm:text-xs md:text-sm lg:text-base text-[#4B5563]"
                      }`}
                  >
                    {program.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div >
    </div>

  );
};
export default TrendingPrograms;
